/**
 * Read-only profile summary for the signed-in user.
 */
import { Navigate, useNavigate } from "react-router-dom";
import PageShell from "../components/ui/PageShell";
import GlassPanel from "../components/ui/GlassPanel";
import Button from "../components/ui/Button";

const DEFAULT_AVATAR_URL = "https://pax-studios.org/images/avatars/g.png";

export default function Profile({ session, loading }) {
  const navigate = useNavigate();
  const user = session?.user || null;

  const displayName = user?.alias?.trim()
    ? user.alias.trim()
    : user?.email?.includes("@")
      ? user.email.split("@")[0]
      : user?.email || "Profile";

  const avatarUrl = user?.avatar_url?.trim() || DEFAULT_AVATAR_URL;

  const joinedText = user?.created_at
    ? new Date(user.created_at).toLocaleDateString()
    : "Unknown";

  if (loading) {
    return null;
  }

  if (!session?.authenticated || !user) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageShell>
      <GlassPanel>
        <div className="space-y-6">
          <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
            <div className="flex items-center gap-4">
              <img
                src={avatarUrl}
                alt=""
                className="h-[72px] w-[72px] rounded-full border-2 border-white/15 object-cover"
              />
              <div>
                <p className="text-xs uppercase tracking-widest text-white/70">Profile</p>
                <h1 className="text-2xl font-bold text-white">{displayName}</h1>
              </div>
            </div>

            <Button type="button" variant="outline" onClick={() => navigate("/profile/edit")}>
              Edit
            </Button>
          </div>

          <hr className="border-white/10" />

          <div className="space-y-2">
            <h2 className="text-base font-bold text-white">Joined:</h2>
            <p className="leading-relaxed text-white/90">{joinedText}</p>
          </div>
        </div>
      </GlassPanel>
    </PageShell>
  );
}
